import React from "react";
import lock from '../../assets/lock.svg';
import finvuLogo from '../../assets/Wordmark.svg';
const Footer = ({customDetails}) => {
    return (
        <footer style={{
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100%',
            background: customDetails?.secondaryColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '14px 0',
            zIndex: 1000
        }}>
            <img src={lock} alt='' style={{ height: '20px' }} />
            <p style={{ margin: 0, fontSize: '12px', color: '#333' }}>Secured data sharing by RBI-Regulated AA</p>
            <img src={finvuLogo} alt='Finvu' style={{ height: '20px' }} />
        </footer>
    );
}

export default Footer;